import React from 'react';
import Card from '../components/card';
import { InfoCopy, InfoLink, InfoList } from '../components/info-link';
import RadioButtons from '../components/RadioButtons';
import { LoanCard } from './card-lenses';

const title = (loan) => {
  switch (loan.get('scenario')) {
    case 'RefiFull':
    case 'RefiQualify':
      return `How are you using this property?`;
    case 'Affordability':
      return `How will you likely use the property?`;
    default:
      return `How will you use this property?`;
  }
};

const Info = (props) => (
  <InfoLink title="Occupancy Types" {...props}>
    <h6>Primary Residence</h6>
    <InfoCopy>
      A property that the borrower or co-borrower occupies as his or her principal residence.
    </InfoCopy>
    <h6>Second Home</h6>
    <InfoList>
      <li>Must be occupied by the borrower for some portion of the year</li>
      <li>Is restricted to one-unit dwellings</li>
      <li>Must be suitable for year-round occupancy</li>
      <li>Borrower must have exclusive control over the property</li>
      <li>Must not be a rental property or timeshare arrangement</li>
    </InfoList>
    <h6>Investment Property</h6>
    <InfoCopy>A property owned but not occupied by the borrower.</InfoCopy>
  </InfoLink>
);

const Occupancy = ({ model, onChange, ...cardProps }) => (
  <Card title={title(model)} info={Info} {...cardProps}>
    <RadioButtons
      name="occupancy"
      value={model.get('occupancy')}
      onChange={onChange.bind(null, 'occupancy')}
      choices={[
        {
          value: 'PrimaryResidence',
          label: 'Primary Residence'
        },
        {
          value: 'SecondHome',
          label: 'Second Home'
        },
        {
          value: 'InvestmentProperty',
          label: 'Investment Property'
        }
      ]}
    />
  </Card>
);

Occupancy.completed = ({ model }) =>
  ['PrimaryResidence', 'SecondHome', 'InvestmentProperty'].includes(model.get('occupancy'));

Occupancy.id = 'Occupancy';

export default LoanCard(Occupancy);



// WEBPACK FOOTER //
// ./src/cards/occupancy.js